// React
import React from 'react'
import classNames from 'classnames'
// Tools
import { useFormatMessage } from '../../intl/intl'
// Components
import CustomSearchTextField from '../common/custom-search-text-field'
// Styles
import useStyles from './OrderSearchTextField.styles'

const OrderSearchTextField = ({ classes, fullWidth, onChange, value }) => {
  const componentClasses = useStyles()
  const placeholder = useFormatMessage({
    id: 'orderSearchTextField.placeHolder',
  })

  return (
    <CustomSearchTextField
      classes={{
        input: classNames(componentClasses.input, classes.input),
        root: classNames(componentClasses.root, classes.root),
        adornedStart: classNames(componentClasses.adornedStart),
      }}
      placeholder={placeholder}
      onChange={event => {
        const text = event.target.value.trim()
        onChange(text)
      }}
      onClickCancelButton={() => {
        onChange('')
      }}
      fullWidth={fullWidth}
      value={value}
    />
  )
}

OrderSearchTextField.defaultProps = {
  classes: {},
  fullWidth: true,
}

export default OrderSearchTextField
